<p-toast></p-toast>
<div class="grid">
    <div class="col-12">
        <div class="card">
            <h5 *ngIf="!objeto.id">Nueva Plantilla de Whatsapp</h5>
            <h5 *ngIf="objeto.id">Plantilla de Whatsapp: {{ objeto.nombre }}</h5>
            <app-cabecera-ventana *ngIf="!loading" 
                [modulo]="modulo" [codigoRegistro]="codigoRegistro" [readonly]="isReadonly()" [esNuevo]="esNuevo()" [activo]="objeto?.activo"
                [cargando]="cargando"
                (eVolver)="volver()" (eNuevo)="nuevo()" (eEditar)="editar()" (eGuardar)="guardar()" (eEliminar)="eliminar()" (eInactivar)="inactivar($event)">
            </app-cabecera-ventana>
            <div *ngIf="loading" class="flex justify-content-center flex-wrap">
                <p-progressSpinner></p-progressSpinner>
            </div>
            <form *ngIf="!loading" [formGroup]="formGroup">
                <p-tabView>
<p-tabPanel header="General">
                        <div class="p-fluid p-formgrid grid">
                            <div class="field col-12 md:col-1">
                                <label htmlFor="id">ID</label>
                                <p-inputNumber inputId="id" formControlName="id" readonly="true"></p-inputNumber>
                            </div>
                            <ng-container *ngIf="currentUser.superusuario">
                                <div class="field col-12 md:col-1">
                                    <label htmlFor="id_empresa">Empresa</label>
                                    <span class="p-input-icon-right">
                                        <input pInputText id="id_empresa" type="text" formControlName="id_empresa" (change)="onEmpresa()" (keydown.control.enter)="!isReadonly() ? onListaEmpresa() : ''" [readOnly]="isReadonly()" />
                                        <i *ngIf="!isReadonly()" style="font-size: 1.2rem;" class="pi pi-search" (click)="onListaEmpresa()"></i>
                                    </span>
                                </div>
                                <div class="field col-12 md:col-2">
                                    <label htmlFor="nombre_empresa">Descripción</label>
                                    <input pInputText id="nombre_empresa" type="text" formControlName="nombre_empresa" readonly />
                                </div>
                            </ng-container>
                            <div class="field col-12 md:col-2">
                                <label htmlFor="fecha">Fecha </label>
                                <p-calendar id="fecha" formControlName="fecha" [showTime]="true" dateFormat="dd/mm/yy" [disabled]="isReadonly()"></p-calendar>
                            </div>
                            <div class="field col-12 md:col-3">
                                <label htmlFor="nombre">Nombre</label>
                                <input pInputText id="nombre" type="text" formControlName="nombre" [readOnly]="isReadonly()" />
                                <small *ngIf="invalidControl('nombre')" style="color: red;">Este campo es requerido.</small>
                            </div>
                            <div class="field col-12 md:col-3">
                                <label htmlFor="estado">Estado</label>
                                <p-dropdown [options]="ESTADOS" formControlName="estado" optionLabel="nombre" optionValue="valor" [readonly]="true" ></p-dropdown>
                            </div>
                        </div>
                        
                        <!--
                            Categoría. Es el único campo nuevo OBLIGATORIO: Meta lo
                            exige y no se puede esconder. Viene con UTILITY por
                            defecto, que es lo que el backend ya asumía, así que quien
                            no lo toca obtiene el comportamiento de siempre.

                            Va antes de los bloques del mensaje porque los condiciona:
                            AUTHENTICATION prohíbe encabezado y define el cuerpo.
                        -->
                        <div class="p-fluid p-formgrid grid">
                            <div class="field col-12 md:col-6">
                                <label htmlFor="category">Categoría</label>
                                <p-dropdown inputId="category" [options]="CATEGORIAS" formControlName="category"
                                    optionLabel="label" optionValue="value" [readonly]="isReadonly()"
                                    (onChange)="onCategoriaChange()"></p-dropdown>
                                <small class="text-500 text-xs">
                                    Meta puede recategorizar la plantilla al aprobarla, y eso cambia el precio por mensaje.
                                </small>
                            </div>
                        </div>

                        <!--
                            Bloques del mensaje y vista previa, lado a lado.

                            El orden de los bloques —encabezado, cuerpo, pie, botones—
                            es EL MISMO que el del mensaje que recibe el cliente. Esa
                            correspondencia es lo que hace innecesario explicar qué es
                            un componente de Meta: el campo de arriba escribe la línea
                            de arriba.
                        -->
                        <div class="grid">
                            <div class="col-12 lg:col-7">

                                <!-- Bloque 1: encabezado -->
                                <p-fieldset legend="Encabezado (opcional)" styleClass="bloque-mensaje mb-3" *ngIf="!esAutenticacion"
                                    (focusin)="enfocarBloque('header')" (focusout)="desenfocarBloque('header')">

                                    <div class="p-fluid p-formgrid grid">
                                        <div class="field col-12 md:col-4">
                                            <label htmlFor="header_format">Tipo</label>
                                            <p-dropdown inputId="header_format" [options]="FORMATOS_HEADER" formControlName="header_format"
                                                optionLabel="label" optionValue="value" [readonly]="isReadonly()"
                                                (onChange)="onFormatoHeaderChange()"></p-dropdown>
                                        </div>

                                        <div class="field col-12 md:col-8" *ngIf="formatoHeader === 'TEXT'">
                                            <label htmlFor="header_text">Texto del encabezado</label>
                                            <input pInputText id="header_text" type="text" formControlName="header_text"
                                                [readOnly]="isReadonly()" [maxlength]="LIMITES.HEADER_TEXTO" />
                                            <small class="text-500 text-xs">
                                                Máximo {{ LIMITES.HEADER_TEXTO }} caracteres y una sola variable.
                                            </small>
                                        </div>

                                        <!--
                                            El archivo vive DENTRO del bloque que lo usa. Antes
                                            era un checkbox suelto más arriba, separado del
                                            dropdown que decide el tipo de encabezado, y los dos
                                            podían contradecirse.
                                        -->
                                        <div class="field col-12" *ngIf="esHeaderMultimedia && !isReadonly()">
                                            <label>Archivo del encabezado</label>
                                            <p-fileUpload
                                                mode="basic"
                                                chooseLabel="Seleccionar {{ nombreFormatoHeader }}"
                                                [auto]="false"
                                                accept="image/*"
                                                maxFileSize="10000000"
                                                [multiple]="false"
                                                (onSelect)="onSelectImagen($event)">
                                            </p-fileUpload>
                                            <small class="text-500 text-xs">
                                                Se sube a Meta al guardar. La aprobación revisa este archivo.
                                            </small>
                                            <div *ngIf="imagenPreview" class="mt-2">
                                                <p-image [src]="imagenPreview" [preview]="true" width="200" styleClass="border-round"></p-image>
                                            </div>
                                        </div>

                                        <div class="field col-12" *ngIf="esHeaderMultimedia && formGroup.value.url_imagen && !imagenPreview">
                                            <label>Archivo actual</label>
                                            <div>
                                                <p-image [src]="formGroup.value.url_imagen" [preview]="true" width="200" styleClass="border-round"></p-image>
                                            </div>
                                        </div>
                                    </div>
                                </p-fieldset>

                                <!-- Bloque 2: cuerpo -->
                                <p-fieldset legend="Cuerpo del mensaje" styleClass="bloque-mensaje mb-3"
                                    (focusin)="enfocarBloque('body')" (focusout)="desenfocarBloque('body')">

                                    <div class="p-fluid p-formgrid grid">
                                        <div class="field col-12">
                                            <textarea pInputTextarea id="mensaje" #mensajeInput formControlName="mensaje"
                                                [readOnly]="isReadonly()" rows="5" class="w-full"
                                                placeholder="Ej: Hola, tu cuota vence el viernes."
                                                (keydown)="onKeydownMensaje($event)"
                                                (keyup)="recordarCursorMensaje()"
                                                (click)="recordarCursorMensaje()"
                                                (select)="recordarCursorMensaje()"></textarea>
                                            <small *ngIf="invalidControl('mensaje')" style="color: red;">Este campo es requerido.</small>

                                            <!--
                                                Una posición ya usada se bloquea: repetirla no agrega
                                                un dato nuevo, y quien la inserta dos veces suele creer
                                                que sí. Apagada y sin click, con el motivo en el tooltip.
                                            -->
                                            <div class="flex align-items-center gap-2 flex-wrap mt-2" *ngIf="!isReadonly()">
                                                <span class="text-500 text-xs">Insertar variable:</span>
                                                <span *ngFor="let posicion of POSICIONES_VARIABLE"
                                                    class="p-tag"
                                                    [ngClass]="variableEnUso(posicion) ? 'opacity-50' : 'p-tag-info cursor-pointer'"
                                                    [pTooltip]="variableEnUso(posicion) ? 'Ya está en el mensaje' : 'Se inserta donde tengas el cursor'"
                                                    tooltipPosition="top"
                                                    (mousedown)="$event.preventDefault()"
                                                    (click)="agregarVariable(posicion, $event)">{{ etiquetaVariable(posicion) }}</span>
                                            </div>
                                            <small class="text-500 text-xs block mt-1" *ngIf="!isReadonly()">
                                                <span class="font-semibold">Ctrl + Espacio</span> inserta la próxima variable donde tengas el cursor, sin soltar el teclado.
                                            </small>
                                            <small class="text-500 text-xs block mt-1" *ngIf="!isReadonly()">
                                                Máximo {{ LIMITES.BODY }} caracteres. El mapeo de cada posición se hace al enviar.
                                            </small>
                                        </div>
                                    </div>
                                </p-fieldset>

                                <!-- Bloque 3: pie -->
                                <p-fieldset legend="Pie del mensaje (opcional)" styleClass="bloque-mensaje mb-3" *ngIf="!esAutenticacion"
                                    (focusin)="enfocarBloque('footer')" (focusout)="desenfocarBloque('footer')">

                                    <div class="p-fluid p-formgrid grid">
                                        <div class="field col-12">
                                            <input pInputText id="footer_text" type="text" formControlName="footer_text"
                                                [readOnly]="isReadonly()" [maxlength]="LIMITES.FOOTER"
                                                placeholder="Ej: Banco Ejemplo S.A." />
                                            <small class="text-500 text-xs">
                                                Máximo {{ LIMITES.FOOTER }} caracteres. No admite variables.
                                            </small>
                                        </div>
                                    </div>
                                </p-fieldset>

                                <!-- Bloque 4: botones -->
                                <p-fieldset legend="Botones (opcional)" styleClass="bloque-mensaje mb-3" *ngIf="!esAutenticacion"
                                    (focusin)="enfocarBloque('buttons')" (focusout)="desenfocarBloque('buttons')">

                                    <div *ngFor="let boton of botones; let i = index" class="flex gap-2 mb-2 align-items-start flex-wrap">
                                        <p-dropdown [options]="TIPOS_BOTON" [ngModel]="boton.tipo"
                                            (ngModelChange)="boton.tipo = $event; resincronizarFlujoConBotones()"
                                            [ngModelOptions]="{ standalone: true }" optionLabel="label" optionValue="value"
                                            [readonly]="isReadonly()" styleClass="w-12rem"></p-dropdown>

                                        <div class="w-12rem">
                                            <input pInputText type="text" [ngModel]="boton.texto"
                                                (ngModelChange)="boton.texto = $event; resincronizarFlujoConBotones()"
                                                [ngModelOptions]="{ standalone: true }" placeholder="Texto del botón"
                                                [readOnly]="isReadonly()" [maxlength]="limiteEtiquetaBoton" class="w-full" />
                                            <small *ngIf="!isReadonly() && boton.tipo === 'QUICK_REPLY'"
                                                [class.text-500]="(boton.texto || '').length <= limiteEtiquetaBoton"
                                                [class.p-error]="(boton.texto || '').length > limiteEtiquetaBoton"
                                                class="text-xs block">
                                                {{ (boton.texto || '').length }}/{{ limiteEtiquetaBoton }}
                                            </small>
                                        </div>

                                        <input pInputText type="text" *ngIf="boton.tipo === 'URL'" [(ngModel)]="boton.url"
                                            [ngModelOptions]="{ standalone: true }" placeholder="https://..."
                                            [readOnly]="isReadonly()" class="flex-1" />

                                        <input pInputText type="text" *ngIf="boton.tipo === 'PHONE_NUMBER'" [(ngModel)]="boton.telefono"
                                            [ngModelOptions]="{ standalone: true }" placeholder="+595981123456"
                                            [readOnly]="isReadonly()" class="w-12rem" />

                                        <button pButton type="button" icon="pi pi-trash" class="p-button-danger p-button-text"
                                            [disabled]="isReadonly()" (click)="quitarBoton(i)"></button>
                                    </div>

                                    <button pButton type="button" label="Agregar botón" icon="pi pi-plus"
                                        class="p-button-outlined p-button-sm"
                                        [disabled]="isReadonly() || !puedeAgregarBoton"
                                        (click)="agregarBoton()"></button>

                                    <small class="text-500 text-xs block mt-2" *ngIf="!flujoActivo">
                                        Hasta {{ LIMITES.BOTONES }} botones. Como máximo 2 de enlace y 1 de teléfono.
                                    </small>

                                    <small class="text-500 text-xs block mt-2" *ngIf="flujoActivo">
                                        Con respuesta automática: hasta {{ limiteQuickReply }} botones de respuesta rápida
                                        ({{ cantidadQuickReply }} cargados) y {{ limiteEtiquetaBoton }} caracteres cada uno.
                                    </small>

                                    <p-message *ngIf="sobranQuickReplyParaElFlujo" severity="error"
                                        styleClass="w-full mt-2"
                                        [text]="'Con respuesta automática, Meta acepta ' + limiteQuickReply + ' botones de respuesta rápida y tenés ' + cantidadQuickReply + '. Quitá los que sobren o apagá la respuesta automática.'"></p-message>

                                    <p-message *ngIf="botonesQueExcedenElFlujo.length" severity="error"
                                        styleClass="w-full mt-2"
                                        [text]="'Con respuesta automática el texto de un botón no puede pasar de ' + limiteEtiquetaBoton + ' caracteres. Acortá: ' + botonesQueExcedenElFlujo.join(', ')"></p-message>

                                    <p-message *ngIf="hayBotonesEscondidos" severity="warn"
                                        [text]="avisoBotonesEscondidos" styleClass="w-full mt-2"></p-message>
                                </p-fieldset>

                                <p-fieldset legend="Respuesta automática (opcional)" styleClass="bloque-mensaje mb-3" *ngIf="!esAutenticacion">
                                    <app-flujo-editor
                                        [botones]="botones"
                                        [definicion]="flujoDefinicion"
                                        (activoChange)="flujoActivo = $event"
                                    ></app-flujo-editor>
                                </p-fieldset>

                                <div class="p-fluid p-formgrid grid" *ngIf="templateWarnings.length > 0">
                                    <div class="field col-12">
                                        <div class="p-3 border-round surface-yellow-50 border-1 border-yellow-200">
                                            <div class="font-semibold text-900 mb-2">Observaciones antes de enviar</div>
                                            <small class="block text-700 mb-2">Estos warnings no impiden guardar ni enviar el template. Son solo recomendaciones para evitar rechazos.</small>
                                            <ul class="m-0 pl-3 text-700">
                                                <li *ngFor="let warning of templateWarnings" class="mb-1">{{ warning }}</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Vista previa: el mensaje armado, como lo recibe el cliente -->
                            <div class="col-12 lg:col-5">
                                <p-card styleClass="preview-plantilla">
                                    <ng-template pTemplate="header">
                                        <div class="flex align-items-baseline justify-content-between gap-2 px-3 pt-3">
                                            <span class="font-semibold">Vista previa</span>
                                            <span class="text-500 text-xs">Como lo recibe el cliente</span>
                                        </div>
                                    </ng-template>

                                    <div class="preview-lienzo">
                                        <div class="preview-globo" *ngIf="hayPreview; else sinPreview">
                                            <div class="preview-media" *ngIf="esHeaderMultimedia"
                                                [class.preview-region-activa]="bloqueEnfocado === 'header'">
                                                <img *ngIf="imagenPreview || formGroup.value.url_imagen"
                                                    [src]="imagenPreview || formGroup.value.url_imagen" alt="" />
                                                <span *ngIf="!imagenPreview && !formGroup.value.url_imagen">
                                                    {{ nombreFormatoHeader }} del encabezado
                                                </span>
                                            </div>

                                            <div class="preview-cuerpo">
                                                <div class="preview-header-texto" *ngIf="previewHeaderTexto"
                                                    [class.preview-region-activa]="bloqueEnfocado === 'header'">
                                                    <span *ngFor="let tramo of tramosPreview(previewHeaderTexto)"
                                                        [class.preview-variable]="tramo.esVariable">{{ tramo.texto }}</span>
                                                </div>

                                                <div class="preview-texto" [class.preview-region-activa]="bloqueEnfocado === 'body'">
                                                    <span *ngFor="let tramo of tramosPreview(previewCuerpo)"
                                                        [class.preview-variable]="tramo.esVariable">{{ tramo.texto }}</span>
                                                </div>

                                                <div class="preview-pie" *ngIf="previewPie"
                                                    [class.preview-region-activa]="bloqueEnfocado === 'footer'">{{ previewPie }}</div>

                                                <span class="preview-hora">10:24</span>
                                            </div>

                                            <div class="preview-botones" *ngIf="previewBotones.length"
                                                [class.preview-region-activa]="bloqueEnfocado === 'buttons'">
                                                <div class="preview-boton" *ngFor="let boton of previewBotonesVisibles">
                                                    <i [class]="iconoBoton(boton.tipo)"></i>
                                                    <span>{{ boton.texto }}</span>
                                                </div>
                                                <div class="preview-boton" *ngIf="hayBotonesEscondidos">
                                                    <i class="pi pi-list"></i>
                                                    <span>Ver todas las opciones</span>
                                                </div>
                                            </div>
                                        </div>

                                        <ng-template #sinPreview>
                                            <div class="preview-vacio">Escribí el cuerpo del mensaje para ver la vista previa.</div>
                                        </ng-template>
                                    </div>

                                    <ng-template pTemplate="footer">
                                        <div class="flex flex-column gap-1 text-500 text-xs">
                                            <span>Lo resaltado en verde son <b>variables</b>: se reemplazan al enviar.</span>
                                            <span *ngIf="hayPreview">Bloques que se envían a Meta: <b>{{ bloquesEnviados.join(' · ') }}</b>.</span>
                                        </div>
                                    </ng-template>
                                </p-card>
                            </div>
                        </div>

                        <!--
                            AUTHENTICATION no es "más estricto": es otra cosa. El texto
                            del cuerpo lo define Meta y no se escribe, y los encabezados
                            están prohibidos.
                        -->
                        <p-message *ngIf="esAutenticacion" severity="info"
                            text="En las plantillas de autenticación el texto lo define Meta y no se puede editar. No admiten encabezado."
                            styleClass="w-full mb-3"></p-message>

                        <!-- Identificadores -->
                        <div class="p-fluid p-formgrid grid">
                            <div class="field col-12 md:col-6">
                                <label htmlFor="meta_template_name">Nombre técnico en Meta</label>
                                <input pInputText id="meta_template_name" type="text" formControlName="meta_template_name" readonly
                                    placeholder="Se genera al guardar" />
                                <small class="text-500 text-xs">Derivado del nombre. Es la identidad de la plantilla en Meta.</small>
                            </div>
                            <div class="field col-12 md:col-4">
                                <label htmlFor="approve_status">Estado de aprobación</label>
                                <div id="approve_status" class="approve-status-readonly">
                                    <ng-container *ngIf="formGroup.value.approve_status; else sinEstadoAprobacion">
                                        <!--
                                            Verde SOLO si se puede enviar. Cualquier otro
                                            estado —pausada, bloqueada, observada— es rojo:
                                            son plantillas que no salen.
                                        -->
                                        <span class="p-tag" [ngClass]="{
                                            'p-tag-success': plantillaUtilizable,
                                            'p-tag-warning': approveStatusNormalizado === 'pending' || approveStatusNormalizado === 'draft' || approveStatusNormalizado === 'in_appeal',
                                            'p-tag-danger': !plantillaUtilizable && approveStatusNormalizado !== 'pending' && approveStatusNormalizado !== 'draft' && approveStatusNormalizado !== 'in_appeal'
                                        }">{{ approveStatusLabel }}</span>
                                    </ng-container>
                                    <ng-template #sinEstadoAprobacion>
                                        <span class="text-500">Sin estado</span>
                                    </ng-template>
                                </div>
                            </div>

                            <div class="field col-12 md:col-2" *ngIf="formGroup.value.id">
                                <label>&nbsp;</label>
                                <button pButton type="button" icon="pi pi-refresh" label="Sincronizar" class="p-button-outlined p-button-sm w-full" (click)="sincronizarEstadoTemplate()"></button>
                            </div>
                            
                            <!-- Motivo del rechazo -->
                            <div class="field col-12" *ngIf="formGroup.value.reject_reason">
                                <label class="text-red-500 font-bold">Motivo del rechazo:</label>
                                <div class="p-2 surface-50 border-round text-red-600">
                                    {{ formGroup.value.reject_reason }}
                                </div>
                            </div>
                        </div>
                        
                        <div class="p-fluid p-formgrid grid">
                            <div class="col-6 md:col-2">
                                <div class="field-checkbox">
                                    <p-checkbox name="activo" id="activo" [binary]="true" formControlName="activo" readonly="true"></p-checkbox>
                                    <label for="activo">Activo</label>
                                </div>
                            </div>
                        </div>
                    </p-tabPanel>
                    <p-tabPanel header="Auditoria">
                        <div class="p-fluid p-formgrid grid">
                            <div class="field col-12 md:col-4">
                                <label htmlFor="nombre_creado_por">Creado por</label>
                                <input pInputText id="cod_creado_por" type="text" formControlName="cod_creado_por" readonly />
                            </div>
                            <div class="field col-12 md:col-4">
                                <label htmlFor="fecha_creacion">Fecha Creación</label>
                                <p-calendar id="fecha_creacion" formControlName="fecha_creacion" [showTime]="true" dateFormat="dd/mm/yy" disabled="true"></p-calendar>
                            </div>
                        </div>
                        <div class="p-fluid p-formgrid grid">
                            <div class="field col-12 md:col-4">
                                <label htmlFor="cod_actualizado_por">Actualizado por</label>
                                <input pInputText id="cod_actualizado_por" type="text" formControlName="cod_actualizado_por" readonly />
                            </div>
                            <div class="field col-12 md:col-4">
                                <label htmlFor="fecha_actualizacion">Fecha Actualización</label>
                                <p-calendar id="fecha_actualizacion" formControlName="fecha_actualizacion" [showTime]="true" dateFormat="dd/mm/yy" disabled="true"></p-calendar>
                            </div>
                        </div>
                        <div class="p-fluid p-formgrid grid">
                            <div class="field col-12 md:col-4">
                                <label htmlFor="cod_inactivado_por">Inactivado por</label>
                                <input pInputText id="cod_inactivado_por" type="text" formControlName="cod_inactivado_por" readonly />
                            </div>
                            <div class="field col-12 md:col-4">
                                <label htmlFor="fecha_inactivacion">Fecha Inactivación</label>
                                <p-calendar id="fecha_inactivacion" formControlName="fecha_inactivacion" [showTime]="true" dateFormat="dd/mm/yy" disabled="true"></p-calendar>
                            </div>
                        </div>
                    </p-tabPanel>
                </p-tabView>
            </form>
        </div>
    </div>
</div>

<app-on-lista [show]="showOnLista" [title]="tituloOnLista" [columns]="columnasOnLista" [service]="serviceOnLista" [recordName]="recordNameOnLista" [filters]="filters"
    (close)="cerrarOnLista($event)">
</app-on-lista>
